<template>
  <div class="index-service">
    
    <!-- 服务业务范围 -->
    <section class="service-scope" data-aos="fade-up">
      <div class="container">
        <div class="section-header">
          <div class="section-line"></div>
          <h2 class="section-title">服务业务范围</h2>
          <p class="section-subtitle">多样的互联网形式供您选择，打造属于自己的互联网+</p>
        </div>
        
        <div class="service-grid">
          <div 
            v-for="(item, index) in bussList" 
            :key="index"
            class="service-card"
            data-aos="zoom-in"
            :data-aos-delay="index * 100"
          >
            <div class="service-icon">
              <img 
                :src="baseUrl + item.busCaseImage" 
                :alt="item.busCaseContent"
                class="service-img"
              />
              <div class="icon-glow"></div>
            </div>
            <h3 class="service-name">{{ item.busCaseName }}</h3>
            <p class="service-desc">{{ item.busCaseDesc }}</p>
            <div class="case-progress">
              <div class="progress-bar">
                <div class="progress-fill" :style="{ width: item.busCaseSort + '%' }"></div>
              </div>
              <span class="progress-text">{{ item.busCaseSort }}%</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 公司理念 -->
    <section class="company-philosophy" data-aos="fade-up">
      <div class="container">
        <div class="philosophy-content">
          <div class="philosophy-text">
            <div class="section-line"></div>
            <h2 class="philosophy-title">{{ serviceIdeaInfo.ideaTitle }}</h2>
            <p class="philosophy-subtitle">{{ serviceIdeaInfo.ideaTitleDesc }}</p>
            <div class="philosophy-description">
              <h3>{{ serviceIdeaInfo.ideaSubTitle }}</h3>
              <p>{{ serviceIdeaInfo.ideaDesc }}</p>
            </div>
          </div>
          <div class="philosophy-image">
            <img 
              :src="isMobile ? serviceIdeaImg[2].path : serviceIdeaImg[1].path" 
              :alt="serviceIdeaImg[1].name"
              class="philosophy-img"
            />
            <div class="image-overlay"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务案例 -->
    <section class="service-cases" data-aos="fade-up">
      <div class="container">
        <div class="section-header">
          <div class="section-line"></div>
          <h2 class="section-title">服务案例</h2>
          <p class="section-subtitle">已为客户定制多种多样的解决方案，助您轻松跨入"互联网+"时代，成为网络上的主宰者！</p>
        </div>
        
        <div class="cases-grid">
          <div 
            v-for="(item, index) in caseList" 
            :key="index"
            class="case-card"
            data-aos="fade-up"
            :data-aos-delay="index * 150"
          >
            <router-link :to="`/case/${item.id}`" class="case-link">
              <div class="case-image">
                <img 
                  :src="baseUrl + item.busCaseImage" 
                  :alt="item.busCaseDesc"
                  class="case-img"
                />
                <div class="case-overlay">
                  <div class="case-hover-content">
                    <span class="view-more">查看详情</span>
                  </div>
                </div>
              </div>
              <div class="case-info">
                <h3 class="case-title">{{ item.busCaseName }}</h3>
                <p class="case-desc">{{ item.busCaseDesc }}</p>
                <div class="case-progress">
                  <div class="progress-bar">
                    <div class="progress-fill" :style="{ width: percentage + '%' }"></div>
                  </div>
                  <!-- <span class="progress-text">{{ percentage }}</span> -->
                </div>
              </div>
            </router-link>
          </div>
        </div>
        
        <div class="view-more-section">
          <router-link to="/product" class="btn btn-primary btn-large">
            查看更多案例
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getServiceCaseList, getServiceCaseListIndex } from '@/api/work/case';

export default {
  name: "IndexService",
  data() {
    return {
      serviceIdeaInfo: {
        ideaTitle: '页面案例宗旨',
        ideaSubTitle: 'Studio Purpose',
        ideaTitleDesc: '专注品牌形象力事业十余年，是一个兼具国际视野、创新动力、全方位跨平台的软件定制化展示开发的个人独立设计。',
        ideaDesc: '专注品牌形象力事业十余年，是一个兼具创新动力、全方位跨平台的软件定制化展示开发的个人独立设计。业务案例涉及APP、WEB网站、企业门户、小程序、管理系统等。'
      },
      serviceIdeaImg: [
        {
          name: 'lefImg',
          path: require('../assets/img/index/service1.png')
        },
        {
          name: 'rightImg',
          path: require('../assets/img/index/kejikuan1.jpg')
        },
        {
          name: 'logoImg',
          path: require('../assets/img/index/kejichang.jpg')
        }
      ],
      caseList: [],
      bussList: [
        {
          busCaseName: 'APP开发',
          busCaseDesc: '专业的移动应用开发服务',
          busCaseImage: require('../assets/img/index/app1.jpg')
        },
        {
          busCaseName: '小程序开发',
          busCaseDesc: '微信小程序、支付宝小程序等',
          busCaseImage: require('../assets/img/index/app2.jpg')
        },
        {
          busCaseName: 'Web网站',
          busCaseDesc: '响应式网站设计与开发',
          busCaseImage: require('../assets/img/index/system1.jpg')
        },
        {
          busCaseName: '门户系统',
          busCaseDesc: '企业门户网站建设',
          busCaseImage: require('../assets/img/index/system2.jpg')
        }
      ],
      percentage: 100,
      baseUrl: this.$baseUrl,
      isMobile: navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i),
    }
  },
  created() {
    this.getServiceCaseListIndex();
    this.getServiceCaseList();
  },
  methods: {
    getServiceCaseList() {
      getServiceCaseList("buss").then(res => {
        if (res.data && res.data.length > 0) {
          this.bussList = res.data;
        }
        // 如果API返回的数据为空，使用默认的业务类型数据
      }).catch(() => {
        // API调用失败时使用默认数据
      })
    },
    getServiceCaseListIndex() {
      getServiceCaseListIndex().then(res => {
        this.caseList = res.data.slice(0, 6);
      })
    },
    toProduct() {
      this.$router.push('/product');
    }
  }
}
</script>

<style lang="less" scoped>
.index-service {
  background: var(--bg-primary);
  color: var(--text-primary);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-header {
  text-align: center;
  margin-bottom: 64px;

  .section-line {
    width: 60px;
    height: 4px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    margin: 0 auto 24px;
    border-radius: 2px;
  }

  .section-title {
    font-size: var(--font-size-4xl);
    font-weight: 700;
    margin-bottom: 16px;
    background: linear-gradient(135deg, #ffffff 0%, #b2bac2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .section-subtitle {
    font-size: var(--font-size-lg);
    color: var(--text-secondary);
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
  }
}

/* 服务案例 */
.service-cases {
  padding: 80px 0 120px;

  .cases-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 32px;
    margin-bottom: 64px;
  }

  .case-card {
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius-lg);
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-8px);
      box-shadow: var(--shadow-heavy);
      border-color: rgba(102, 126, 234, 0.3);
    }
  }

  .case-link {
    text-decoration: none;
    color: inherit;
    display: block;
  }

  .case-image {
    position: relative;
    height: 200px;
    overflow: hidden;

    .case-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }

    .case-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(10, 25, 41, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    .case-hover-content {
      color: white;
      text-align: center;

      .view-more {
        font-size: var(--font-size-lg);
        font-weight: 600;
      }
    }
  }

  .case-card:hover .case-image {
    .case-img {
      transform: scale(1.1);
    }

    .case-overlay {
      opacity: 1;
    }
  }

  .case-info {
    padding: 24px;

    .case-title {
      font-size: var(--font-size-lg);
      font-weight: 600;
      margin-bottom: 8px;
      color: var(--text-primary);
    }

    .case-desc {
      color: var(--text-secondary);
      margin-bottom: 16px;
      line-height: 1.6;
    }

    .case-progress {
      display: flex;
      align-items: center;
      gap: 12px;

      .progress-bar {
        flex: 1;
        height: 6px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
        overflow: hidden;

        .progress-fill {
          height: 100%;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 3px;
          transition: width 0.3s ease;
        }
      }

      .progress-text {
        font-size: var(--font-size-sm);
        color: var(--text-secondary);
        font-weight: 600;
      }
    }
  }

  .view-more-section {
    text-align: center;

    .btn-large {
      padding: 16px 32px;
      font-size: var(--font-size-lg);
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }
  }
}

/* 公司理念 */
.company-philosophy {
  padding: 80px 0;
  background: var(--bg-secondary);

  .philosophy-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 64px;
    align-items: center;
  }

  .philosophy-text {
    .section-line {
      width: 60px;
      height: 4px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      margin-bottom: 24px;
      border-radius: 2px;
    }

    .philosophy-title {
      font-size: var(--font-size-3xl);
      font-weight: 700;
      margin-bottom: 16px;
      background: linear-gradient(135deg, #ffffff 0%, #b2bac2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .philosophy-subtitle {
      font-size: var(--font-size-lg);
      color: var(--text-secondary);
      margin-bottom: 32px;
      line-height: 1.6;
    }

    .philosophy-description {
      h3 {
        font-size: var(--font-size-xl);
        font-weight: 600;
        margin-bottom: 16px;
        color: var(--text-primary);
      }

      p {
        color: var(--text-secondary);
        line-height: 1.8;
      }
    }
  }

  .philosophy-image {
    position: relative;
    border-radius: var(--border-radius-lg);
    overflow: hidden;

    .philosophy-img {
      width: 100%;
      height: 400px;
      object-fit: cover;
      transition: transform 0.3s ease;
    }

    .image-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    &:hover {
      .philosophy-img {
        transform: scale(1.05);
      }

      .image-overlay {
        opacity: 1;
      }
    }
  }
}

/* 服务业务范围 */
.service-scope {
  padding: 120px 0 80px;

  .service-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 32px;
    max-width: 1200px;
    margin: 0 auto;
  }

  .service-card {
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius-lg);
    padding: 32px;
    text-align: center;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.1), transparent);
      transition: left 0.5s ease;
    }

    &:hover::before {
      left: 100%;
    }

    &:hover {
      transform: translateY(-8px);
      box-shadow: var(--shadow-heavy);
      border-color: rgba(102, 126, 234, 0.3);
    }
  }

  .service-icon {
    position: relative;
    width: 100px;
    height: 100px;
    margin: 0 auto 24px;

    .service-img {
      width: 100%;
      height: 100%;
      border-radius: 16px;
      object-fit: cover;
      position: relative;
      z-index: 2;
      transition: transform 0.3s ease;
    }

    .icon-glow {
      position: absolute;
      top: -8px;
      left: -8px;
      right: -8px;
      bottom: -8px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 20px;
      opacity: 0.2;
      z-index: 1;
      transition: all 0.3s ease;
    }
  }

  .service-card:hover {
    .icon-glow {
      opacity: 0.4;
      transform: scale(1.05);
    }
    
    .service-img {
      transform: scale(1.05);
    }
  }

  .service-name {
    font-size: var(--font-size-xl);
    font-weight: 700;
    margin-bottom: 12px;
    color: var(--text-primary);
    text-align: center;
  }

  .service-desc {
    color: var(--text-secondary);
    line-height: 1.6;
    text-align: center;
    font-size: var(--font-size-sm);
  }

  .case-progress {
      display: flex;
      align-items: center;
      gap: 12px;

      .progress-bar {
        flex: 1;
        height: 6px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
        overflow: hidden;

        .progress-fill {
          height: 100%;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 3px;
          transition: width 0.3s ease;
        }
      }

      .progress-text {
        font-size: var(--font-size-sm);
        color: var(--text-secondary);
        font-weight: 600;
      }
    }
}

/* 服务案例 */
.service-cases {
  padding: 80px 0 120px;

  .cases-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 32px;
    margin-bottom: 64px;
  }

  .case-card {
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius-lg);
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-8px);
      box-shadow: var(--shadow-heavy);
      border-color: rgba(102, 126, 234, 0.3);
    }
  }

  .case-link {
    text-decoration: none;
    color: inherit;
    display: block;
  }

  .case-image {
    position: relative;
    height: 200px;
    overflow: hidden;

    .case-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }

    .case-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(10, 25, 41, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    .case-hover-content {
      color: white;
      text-align: center;

      .view-more {
        font-size: var(--font-size-lg);
        font-weight: 600;
      }
    }
  }

  .case-card:hover .case-image {
    .case-img {
      transform: scale(1.1);
    }

    .case-overlay {
      opacity: 1;
    }
  }

  .case-info {
    padding: 24px;

    .case-title {
      font-size: var(--font-size-lg);
      font-weight: 600;
      margin-bottom: 8px;
      color: var(--text-primary);
    }

    .case-desc {
      color: var(--text-secondary);
      margin-bottom: 16px;
      line-height: 1.6;
    }

    .case-progress {
      display: flex;
      align-items: center;
      gap: 12px;

      .progress-bar {
        flex: 1;
        height: 6px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
        overflow: hidden;

        .progress-fill {
          height: 100%;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 3px;
          transition: width 0.3s ease;
        }
      }

      .progress-text {
        font-size: var(--font-size-sm);
        color: var(--text-secondary);
        font-weight: 600;
      }
    }
  }

  .view-more-section {
    text-align: center;

    .btn-large {
      padding: 16px 32px;
      font-size: var(--font-size-lg);
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }
  }
}

@media (max-width: 1024px) {
  .service-scope {
    .service-grid {
      grid-template-columns: repeat(3, 1fr);
      gap: 28px;
    }
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 16px;
  }

  .section-header {
    margin-bottom: 48px;

    .section-title {
      font-size: var(--font-size-3xl);
    }
  }

  .service-scope {
    padding: 80px 0 60px;

    .service-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }

    .service-icon {
      width: 80px;
      height: 80px;
    }
  }

  .company-philosophy {
    padding: 60px 0;

    .philosophy-content {
      grid-template-columns: 1fr;
      gap: 40px;
    }

    .philosophy-image {
      .philosophy-img {
        height: 300px;
      }
    }
  }

  .service-cases {
    padding: 60px 0 80px;

    .cases-grid {
      grid-template-columns: 1fr;
      gap: 24px;
    }
  }
}

@media (max-width: 480px) {
  .service-scope {
    .service-grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    .service-icon {
      width: 70px;
      height: 70px;
    }
  }
}
</style>
